import React, { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";
import { getInitials } from "@/lib/utils";

interface CachedAvatarProps {
  src?: string;
  alt: string;
  fallback?: string;
  onError?: () => void;
  isSquircle?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  sm: "h-6 w-6 text-xs",
  md: "h-8 w-8 text-sm",
  lg: "h-10 w-10 text-sm",
  xl: "h-12 w-12 text-base",
};

export const CachedAvatar: React.FC<CachedAvatarProps> = ({
  src,
  alt,
  fallback,
  onError,
  isSquircle = false,
  className,
  size = "lg",
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
    onError?.();
  };

  const handleImageLoad = () => {
    setImageError(false);
  };

  // Gerar fallback automático a partir do nome se não fornecido
  const generatedFallback = fallback || getInitials(alt);

  return (
    <Avatar
      className={`${sizeClasses[size]} ${className || ""}`}
      isSquircle={isSquircle}
    >
      {src && !imageError && (
        <AvatarImage
          src={src}
          alt={alt}
          isSquircle={isSquircle}
          onError={handleImageError}
          onLoad={handleImageLoad}
        />
      )}
      <AvatarFallback isSquircle={isSquircle}>
        {generatedFallback}
      </AvatarFallback>
    </Avatar>
  );
};

CachedAvatar.displayName = 'CachedAvatar';